<template>
  <div class="form-group">
    <label class="form-label">Страховой продукт*</label>
    <CustomSelect name="anticrisisInsuranceProduct" @initialize="onInitialize" @itemSelected="onItemSelected">
      <option data-component="PersonalProtection" value="AccidentAndDiseaseInsurance">Страхование от несчастного случая и болезни</option>
      <option data-component="BankCardProtection" value="BankCardInsurance">Страхование банковских карт</option>
      <option data-component="WeatherInTheHouse" value="ApartmentInsurance">Страхование квартир</option>
      <option data-component="JobLossOrSalaryDecreaseInsurance" value="JobLossOrSalaryDecreaseInsurance">Страхование от потери работы/снижения заработной платы</option>
    </CustomSelect>
  </div>

  <component :is="anticrisisComponent" v-bind="dynamicProps"></component>
</template>

<script>
import PersonalProtection from "@/components/insurances/PersonalProtection/PersonalProtection";
import BankCardProtection from "@/components/insurances/BankCardProtection/BankCardProtection";
import WeatherInTheHouse from "@/components/insurances/WeatherInTheHouse/WeatherInTheHouse";
import JobLossOrSalaryDecreaseInsurance from "@/components/insurances/JobLossOrSalaryDecreaseInsurance/JobLossOrSalaryDecreaseInsurance";
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import CustomSelect from "@/components/utils/CustomSelect";

export default {
  anotherNameLife: "anticrisis",
  components: {
    CustomSelect, PersonalProtection,
    BankCardProtection, WeatherInTheHouse,
    JobLossOrSalaryDecreaseInsurance
  },
  methods: {
    onInitialize(event){
      this.$store.commit(mns.SET_ANTICRISIS_INSURANCE, event.getValue().value);
      this.$store.commit(mns.SET_ANTICRISIS_COMPONENT, event.getValue().customProperties.component);
    },
    onItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_ANTICRISIS_INSURANCE, choice.value);
      this.$store.commit(mns.SET_ANTICRISIS_COMPONENT, choice.customProperties.component);
    },
  },
  computed: {
    ...mapGetters(['anticrisisComponent',]),
    dynamicProps(){
      if (this.anticrisisComponent == 'PersonalProtection')
        return { tempDisability: true }
      else
        return { }
    }
  },
}
</script>

<style scoped>

</style>